/**
 * product.ads-images — lightbox carrusel (bebedero, bolsa, cepillo gallery-preview).
 * Swipe horizontal, thumbs abajo, drag vertical para cerrar.
 */
(function () {
  if (window.__menvoraAdsImagesGallery) return;
  window.__menvoraAdsImagesGallery = true;

  var DISMISS_THRESHOLD = 96;
  var DISMISS_VELOCITY = 0.55;

  function slides(track) {
    return Array.prototype.slice.call(track.children).filter(function (el) {
      return el && el.getAttribute && el.getAttribute('data-media-id');
    });
  }

  function stopClose(e) {
    e.stopPropagation();
  }

  function isProtectedTarget(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(
      '.product-media-modal__toggle,' +
        '[data-menvora-gallery-close],' +
        '[data-menvora-gallery-thumbs],' +
        '[data-menvora-gallery-thumb],' +
        '[data-menvora-gallery-prev],' +
        '[data-menvora-gallery-next],' +
        '[data-menvora-gallery-track] img'
    );
  }

  function bindProtectedSurface(el) {
    if (!el) return;
    ['click', 'pointerup'].forEach(function (type) {
      el.addEventListener(type, stopClose);
    });
  }

  function initModal(modal) {
    if (!modal || modal.__menvoraGalleryBound) return;
    modal.__menvoraGalleryBound = true;

    var sheet = modal.querySelector('[data-menvora-gallery-sheet]');
    var track = modal.querySelector('[data-menvora-gallery-track]');
    var counter = modal.querySelector('[data-menvora-gallery-counter]');
    var prevBtn = modal.querySelector('[data-menvora-gallery-prev]');
    var nextBtn = modal.querySelector('[data-menvora-gallery-next]');
    var chrome = modal.querySelector('[data-menvora-gallery-chrome]');
    var thumbsWrap = modal.querySelector('[data-menvora-gallery-thumbs]');
    var thumbBtns = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-menvora-gallery-thumb]'))
      : [];
    if (!track || !sheet) return;

    var index = 0;
    var syncing = false;
    var drag = null;

    function total() {
      return slides(track).length;
    }

    function updateThumbs() {
      thumbBtns.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (thumbsWrap && thumbBtns[index]) {
        var btn = thumbBtns[index];
        var left = btn.offsetLeft - (thumbsWrap.clientWidth - btn.offsetWidth) / 2;
        if (typeof thumbsWrap.scrollTo === 'function') {
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }
    }

    function updateChrome() {
      var n = total();
      if (counter) counter.textContent = n ? index + 1 + ' / ' + n : '0 / 0';
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= n - 1;
      slides(track).forEach(function (el, i) {
        el.classList.toggle('active', i === index);
      });
      updateThumbs();
    }

    function goTo(i, behavior) {
      var list = slides(track);
      if (!list.length) return;
      index = Math.max(0, Math.min(list.length - 1, i));
      syncing = true;
      var target = list[index];
      var left = target.offsetLeft;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: behavior || 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      updateChrome();
      window.setTimeout(function () {
        syncing = false;
      }, 320);
    }

    function syncFromScroll() {
      if (syncing) return;
      var list = slides(track);
      if (!list.length) return;
      var best = 0;
      var bestDist = Infinity;
      var center = track.scrollLeft + track.clientWidth / 2;
      list.forEach(function (el, i) {
        var mid = el.offsetLeft + el.offsetWidth / 2;
        var dist = Math.abs(mid - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      if (best !== index) {
        index = best;
        updateChrome();
      }
    }

    function resetSheetTransform() {
      sheet.style.transform = '';
      sheet.style.opacity = '';
      modal.classList.remove('is-dragging', 'is-dismissing');
    }

    function onOpen() {
      resetSheetTransform();
      var openerId = modal.openedBy && modal.openedBy.getAttribute
        ? modal.openedBy.getAttribute('data-media-id')
        : null;
      var list = slides(track);
      var start = 0;
      if (openerId) {
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].getAttribute('data-media-id')) === String(openerId)) {
            start = i;
            break;
          }
        }
      }
      window.requestAnimationFrame(function () {
        goTo(start, 'auto');
      });
    }

    function dismissModal() {
      modal.classList.add('is-dismissing');
      sheet.style.transform = drag && drag.lastY > 0 ? 'translateY(110vh)' : 'translateY(-110vh)';
      sheet.style.opacity = '0';
      window.setTimeout(function () {
        if (typeof modal.hide === 'function') modal.hide();
        resetSheetTransform();
      }, 240);
    }

    function closeFromBackdrop() {
      if (!modal.hasAttribute('open') || modal.classList.contains('is-dragging')) return;
      if (typeof modal.hide === 'function') modal.hide();
    }

    function onDragStart(e) {
      if (!modal.hasAttribute('open') || e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('[data-menvora-gallery-thumb], [data-menvora-gallery-prev], [data-menvora-gallery-next], [data-menvora-gallery-close], .product-media-modal__toggle')) {
        return;
      }
      drag = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        lastY: 0,
        lastT: e.timeStamp,
        mode: null,
      };
    }

    function onDragMove(e) {
      if (!drag || drag.pointerId !== e.pointerId) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;

      if (!drag.mode) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        drag.mode = Math.abs(dy) > Math.abs(dx) * 1.15 ? 'vertical' : 'horizontal';
        if (drag.mode === 'vertical') {
          modal.classList.add('is-dragging');
          if (sheet.setPointerCapture) sheet.setPointerCapture(e.pointerId);
        } else {
          drag = null;
          return;
        }
      }

      if (drag.mode !== 'vertical') return;
      e.preventDefault();
      drag.lastY = dy;
      drag.lastT = e.timeStamp;
      var damped = dy * 0.92;
      sheet.style.transform = 'translateY(' + damped + 'px)';
      var fade = Math.max(0.35, 1 - Math.min(Math.abs(damped) / 320, 0.65));
      sheet.style.opacity = String(fade);
    }

    function onDragEnd(e) {
      if (!drag || drag.pointerId !== e.pointerId) return;
      var dy = drag.lastY;
      var shouldDismiss = Math.abs(dy) >= DISMISS_THRESHOLD;
      drag = null;

      if (!modal.classList.contains('is-dragging')) return;
      modal.classList.remove('is-dragging');

      if (shouldDismiss) {
        dismissModal();
      } else {
        resetSheetTransform();
      }
    }

    if (chrome) {
      chrome.addEventListener('pointerup', stopClose);
      chrome.addEventListener('pointerdown', stopClose);
      chrome.addEventListener('click', stopClose);
    }
    if (thumbsWrap) {
      bindProtectedSurface(thumbsWrap);
    }
    if (prevBtn) bindProtectedSurface(prevBtn);
    if (nextBtn) bindProtectedSurface(nextBtn);

    track.querySelectorAll('img').forEach(bindProtectedSurface);
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stopClose(e);
        goTo(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stopClose(e);
        goTo(index + 1);
      });
    }

    thumbBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        stopClose(e);
        goTo(i);
      });
    });

    modal.querySelectorAll('[data-menvora-gallery-close]').forEach(function (btn) {
      bindProtectedSurface(btn);
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          stopClose(e);
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          dismissModal();
        },
        true
      );
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    sheet.addEventListener('pointerdown', onDragStart);
    sheet.addEventListener('pointermove', onDragMove);
    sheet.addEventListener('pointerup', onDragEnd);
    sheet.addEventListener('pointercancel', onDragEnd);

    modal.addEventListener('click', function (e) {
      if (isProtectedTarget(e.target)) return;
      closeFromBackdrop();
    });

    modal.addEventListener('pointerup', function (e) {
      if (isProtectedTarget(e.target)) return;
      closeFromBackdrop();
    });

    modal.addEventListener('keyup', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(index + 1);
      }
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open') {
          if (modal.hasAttribute('open')) onOpen();
          else resetSheetTransform();
        }
      });
    });
    observer.observe(modal, { attributes: true });

    if (modal.hasAttribute('open')) onOpen();
  }

  function boot() {
    document.querySelectorAll('[data-menvora-gallery-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
